import Component from '../core/Component'

export const explode = element => element
    .textContent
    .trim()
    .split('')
    .map(char => `<span class="u-char">${char === ' ' ? '&nbsp;' : char}</span>`)
    .join('')

export default class WordExploder extends Component {

    prepare() {
        this.element.innerHTML = explode(this.element)
    }
}